
/* ===== VELANTIS_HERO_PLAY — asegura que el video del hero se reproduzca ===== */
(function(){
  function play(){ var v=document.querySelector('.vh-video'); if(!v) return; v.muted=true;
    var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
  if(document.readyState!=='loading') play(); else document.addEventListener('DOMContentLoaded',play);
  window.addEventListener('hashchange',function(){ setTimeout(play,60); });
  document.addEventListener('visibilitychange',function(){ if(!document.hidden) play(); });
})();
